export default "<h3>December 2, 2018</h3>\r\n<p>Update 0.6 adds tier 4 races!</p>";